var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-field',_vm._g(_vm._b({ref:"vanField",staticClass:"nio-form-item",attrs:{"value":_vm.value},scopedSlots:_vm._u([{key:"input",fn:function(){return [_vm._t("default",null,{"error":_vm.error,"message":_vm.message})]},proxy:true}],null,true)},'van-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }